export default __webpack_public_path__ + "static/media/addlogo.127f8b7d.svg";